module.exports = __webpack_public_path__ + "img/mayacrew-logo.459a2c19.png";